import { ReactNode } from 'react';

import { create } from 'zustand';

interface FormLayoutStore {
  info: ReactNode | null;
  setInfo: (content: ReactNode) => void;
  actions: ReactNode | null;
  setActions: (content: ReactNode) => void;
}
export const useFormTopbarStore = create<FormLayoutStore>((set) => ({
  info: null,
  setInfo: (content) => set({ info: content }),
  actions: null,
  setActions: (content) => set({ actions: content }),
}));
